export enum DateFormatEnum {
	DateFormat = 'YYYY.MM.DD',
	DateInverseFormat = 'DD.MM.YYYY',
	DateTimeFormat = 'YYYY.MM.DD HH:mm:ss',
	DateTimeInverseFormat = 'DD.MM.YYYY HH:mm:ss',
	CustomDateFormat = 'yyyy/MM/dd HH:mm:ss',
	CustomDateRangeFormat = 'MM-DD-YYYY HH:mm:ss',
}
